import { call } from 'redux-saga/effects';
import { reservations } from 'mz-sdk';

/**
 * Get reservation object from SDK and handle error
 * @param  {string} id   The id to get reservation
 */
export default function* getReservation(id, ondemand) {
  try {
    const reservation = yield call(reservations.get, { id, ondemand });
    return reservation;
  } catch (error) {
    return null;
  }
}
